import { render } from "./WeekdayForm.vue?vue&type=template&id=5b852b91"
import script from "./WeekdayForm.vue?vue&type=script&lang=js"
export * from "./WeekdayForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__